module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"dates":"Termine","noDatesAvailable":"Keine Termine vorhanden","online":"Online","theRegistrationPeriodEndsOn":"Die Anmeldefrist endet am {date}."},"en":{"dates":"Dates","noDatesAvailable":"No dates available","online":"Online","theRegistrationPeriodEndsOn":"The registration period ends on {date}."}}')
  delete Component.options._Ctor
}
